import React, { useState } from 'react';

export default function InvitePartner({ inviteCode }) {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(inviteCode);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className="balance-display" style={{ marginBottom: '4px' }}>
            <div className="balance-label">Waiting for partner</div>
            <p style={{
                color: 'var(--text-2)',
                marginBottom: '16px',
                fontSize: '15px'
            }}>
                Share this code with your partner so they can join your space.
            </p>

            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '12px',
                marginBottom: '16px'
            }}>
                <div style={{
                    fontSize: '32px',
                    fontWeight: '700',
                    letterSpacing: '4px',
                    color: 'var(--accent-dark)',
                    fontFamily: 'monospace'
                }}>
                    {inviteCode}
                </div>
            </div>

            <button
                className="submit-btn"
                onClick={handleCopy}
                style={{ maxWidth: '200px', margin: '0 auto' }}
            >
                {copied ? 'Copied!' : 'Copy Code'}
            </button>
        </div>
    );
}
